import React from 'react';
import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom'; // Cambiar a HashRouter

import Nav from './components/Nav';

import Inicio from './views/Inicio';
import Galeria from './views/Galeria';
import Menu from './views/Menu';
import Sucursales from './views/Sucursales';
import Footer from './components/Footer';
import BackOffice from './views/BackOffice'

function App() {
  return (
    <Router> {/* Ahora usando HashRouter */}
      <div className="App">
        <Nav />
        <Routes>
          <Route path='/' element={<Inicio />} />
          <Route path='/galeria' element={<Galeria />} />
          <Route path='/menu' element={<Menu />} />
          <Route path='/sucursales' element={<Sucursales />} />
          <Route path='/BackOffice' element={<BackOffice />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
